import { useUrl } from "hooks/application/useUrl";

export const useToken = () => {
  const url = useUrl();
  const queryValues = url.getQueryValues();

  return queryValues.token;
};
